export default __webpack_public_path__ + "static/media/brutality.54778de4.png";